export default __webpack_public_path__ + "static/frame-video-733395323ac0af6e11dd3b8bf15e06f6.mp4";